import type { UpdatesResponse } from '@manaro/contracts'
import { formatDate, formatRelative, plural } from '@/shared/lib/format.ts'

interface UpdatesSummaryProps {
  meta: UpdatesResponse['meta']
  upcomingCount: number
}

export function UpdatesSummary({ meta, upcomingCount }: UpdatesSummaryProps) {
  const parts = [
    meta.releasesLast30Days > 0
      ? `${meta.releasesLast30Days} ${plural(meta.releasesLast30Days, ['релиз', 'релиза', 'релизов'])} за 30 дней`
      : 'за последние 30 дней релизов не было',
    upcomingCount > 0
      ? `${upcomingCount} ${plural(upcomingCount, ['обновление', 'обновления', 'обновлений'])} в работе`
      : 'в работе сейчас ничего нет',
  ]

  return (
    <div className="mb-5.5 flex flex-wrap items-center gap-x-2.5 gap-y-2 border-b border-line pb-5.5 text-[13.5px] text-ink-muted">
      {meta.lastReleaseAt && (
        <>
          <span className="inline-flex items-center gap-2">
            <span className="size-[7px] rounded-full bg-brand" />
            Последний релиз — {formatDate(meta.lastReleaseAt)}, {formatRelative(meta.lastReleaseAt)}
          </span>
          <span className="text-[#d6d0c4]">·</span>
        </>
      )}

      {parts.map((part, index) => (
        <span key={part} className="inline-flex items-center gap-2.5">
          {index > 0 && <span className="text-[#d6d0c4]">·</span>}
          {part}
        </span>
      ))}

    </div>
  )
}
